import Image from "next/legacy/image";
import { blurDataURL } from "../../../utils/constants/images";

const PeopleBioAvatar = ({ image }) => {
  return (
    <>
      <div className="relative text-base mx-auto max-w-prose">
        <figure>
          <div className="aspect-w-12 aspect-h-7 lg:mx-auto">
            <div className="rounded-md shadow-lg object-cover object-center absolute">
              <Image
                src={image}
                alt="Memebr Avatar"
                objectFit="contain"
                layout="fill"
                quality={100}
                placeholder="blur"
                blurDataURL={blurDataURL}
                className="rounded-md shadow-lg object-cover object-center"
              />
            </div>
          </div>
        </figure>
      </div>
    </>
  );
};

export default PeopleBioAvatar;
